<template>
  <div :style="[colorStyle, innerBackgroundStyle]" class="bigMetric">
    <div class="bigMetric-value">
      <odometer-wrapper :class="{ 'neb_duration': unit === 'duration' }" :value="mungedNumber" :format="odometerFormat">
      </odometer-wrapper>
      <span class="bigMetric-unit" v-if="unit === 'percent'">%</span>
    </div>
    <div :style="[backgroundStyle]" class="bigMetric-label">
      <span :style="innerColorStyle">{{ label }}</span>
    </div>
  </div>
</template>

<script>
  import OdometerWrapper from '@/components/OdometerWrapper'
  import moment from 'moment'
  export default {
    name: 'animated-metric',
    components: {OdometerWrapper},
    props: {
      /**
       * The value to display. Should be pre converted into the correct format. For instance, if you have a
       * decimal value and would like to display it as a percentage, you would multiply it by 100 before passing it
       * to `AnimatedMetric`.
       */
      value: {
        type: [Number, String],
        required: true
      },
      /**
       * The primary color of the metric container.
       */
      color: {
        type: String,
        required: true
      },
      /**
       * The color of the component background(and label).
       */
      backgroundColor: {
        type: String,
        required: true
      },
      label: {
        type: String,
        required: true
      },
      /**
       * The type of value being passed. Options are `['number', 'percent', 'duration']`. Used for visul formatting.
       */
      unit: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        dataType: 'number'
      }
    },
    computed: {
      colorStyle () {
        return {
          color: this.color,
          borderColor: this.color
        }
      },
      backgroundStyle () {
        return {
          background: this.color
        }
      },
      innerBackgroundStyle () {
        return {
          background: this.backgroundColor
        }
      },
      innerColorStyle () {
        return {
          color: this.backgroundColor
        }
      },
      mungedNumber () {
        if (this.unit === 'duration') {
          const d = moment.duration(this.value, 's')
          let timeFormat = 'mmss'
          if (d._data.hours > 0) {
            timeFormat = 'hhmmss'
          }
          return '1' + moment(d._data).format(timeFormat)  // This is a hack. The Odometer lib removes prefixed zeroes
        }
        return this.value
      },
      odometerFormat () {
        return this.unit === 'duration' ? '(:dd)' : '(,ddd).dd'
      }
    }
  }
</script>

<style scoped lang="scss">
  .bigMetric {
    text-align: center;
    border: 2px solid;
    border-color: black;  /* this attribute is dynamic */
    border-bottom: 0;

    &-value {
      font-size: 36px;
      font-weight: bold;
      padding: 20px 0;
      top: 3px; /* this positioning compensates for extra space on the bottom of the layer */
      position: relative;
    }

    &-unit {
      position: relative;
      left: -8px;
    }

    &-label {
      font-size: 12px;
      letter-spacing: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: black; /* this attribute is dynamic */
      color: #FFF; /* this attribute is dynamic */
      padding: 15px 0;
      text-transform: uppercase;
      font-weight: bold;
    }
  }
</style>

<style lang="scss">
  .neb_duration.odometer {
    .odometer-inside .odometer-digit:first-child,
    .odometer-inside .odometer-formatting-mark:nth-child(2) {
      display: none !important;
    }
  }
</style>
